import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map, timer } from 'rxjs';

@Component({
  selector: 'eiq-loader',
  templateUrl: 'loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  takingLongerInd$ = timer(5000).pipe(map(() => true));
}
